import script from "./Broadcast.vue?vue&type=script&lang=ts&setup=true"
export * from "./Broadcast.vue?vue&type=script&lang=ts&setup=true"

import "./Broadcast.vue?vue&type=style&index=0&id=0cb30740&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cb30740"]])

export default __exports__